// frontend/src/LoginPage.js
import React, { useState } from 'react';
import './App.css'; // Reuse existing CSS

function LoginPage({ setIsAuthenticated, setAuthUsername }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Login successful for:", data.username);
                setAuthUsername(data.username);
                setIsAuthenticated(true);
                console.log("Authentication state updated.");
            } else {
                setError(data.error || 'Login failed. Please try again.');
                setIsAuthenticated(false);
                setAuthUsername('');
            }
        } catch (err) {
            console.error("Login error:", err);
            setError('An network error occurred during login. Please check connection.');
            setIsAuthenticated(false);
            setAuthUsername('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleLogin} className="login-form">
                {/* UPDATED App Name */}
                <h2>Pearl Login</h2>
                {error && <div className="error">{error}</div>}
                <div className="form-section">
                    <label htmlFor="login-username">Username</label>
                    <input
                        type="text"
                        id="login-username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        disabled={loading}
                        autoComplete="username"
                    />
                </div>
                <div className="form-section">
                    <label htmlFor="login-password">Password</label>
                    <input
                        type="password"
                        id="login-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        disabled={loading}
                        autoComplete="current-password"
                    />
                </div>
                <button type="submit" disabled={loading || !username || !password}>
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </form>
        </div>
    );
}

export default LoginPage;
